import { render, staticRenderFns } from "./Gen3Home.vue?vue&type=template&id=c26dae58&scoped=true&"
import script from "./Gen3Home.vue?vue&type=script&lang=js&"
export * from "./Gen3Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26dae58",
  null
  
)

export default component.exports